import _asyncToGenerator from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/asyncToGenerator";
import _toConsumableArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
import './Articles.css';
import React, { useRef } from 'react';
import { get, getTags, getDictionaryItem, getListingItemURL, getColorByTheme, canUseDOM, getPageThemeColors } from '../../utils'; // eslint-disable-line
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import LazyPicture from '../atoms/LazyPicture';
import { ReactComponent as ChevronRight } from '../../resources/icons/IconChevronRightLight.svg';
import { ReactComponent as ChevronLeft } from '../../resources/icons/IconChevronLeftLight.svg';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import CarouselProvider from '../atoms/CarouselProvider/CarouselProvider';
import { injectImageResolution, pathJoin, getMediaHost } from '../../utils';
import getListing, { loadCategoryAlgoliaResults, isTagsRule } from '../../utils/getListing';
import FavouriteBtn from '../atoms/FavouriteBtn/FavouriteBtn';
import RouterLink from '../atoms/RouterLink';
import { tealiumClickFunc, tealiumMergeClickNewData } from '../../utils/tealium';
import ScrollAnimation from 'react-animate-on-scroll';
import { generatrURLFromTags, getFeaturedItemAndList } from '../../utils';
import { resolveListPersonalization } from '../../utils/resolveListPersonalization';
import { algoliaScoredCondition } from '../../utils/algoliaScoredCondition';
import { usePersonalizedList } from '@uniformdev/personalize-react';
import { generateSeeMoreTagsFromRules } from '../../utils/getListing';
import { useIsVisible } from '../../utils/useIsVisible';
import { convertToAnalyticObject } from '../../utils/analytics';

//type is coming from M31_News module

var baseImage = process.env.REACT_APP_MEDIA_HOST ? process.env.REACT_APP_MEDIA_HOST : '';
var setDateFormat = function setDateFormat(date, lang) {
  return new Date(date).toLocaleDateString(lang, {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });
};
var renderImage = function renderImage(item, width, height, alt, imgClassName, bannerClickAnalytics, params, hostLink) {
  if (!get(item, 'image')) return null;
  var imgSrc = injectImageResolution("".concat(pathJoin([getMediaHost(), item.image])), width, height);
  return /*#__PURE__*/React.createElement(RouterLink, {
    openInSameTab: true,
    href: getListingItemURL(hostLink, item.urlSlug, item.url),
    onClick: function onClick() {
      return tealiumClickFunc(tealiumMergeClickNewData(bannerClickAnalytics, params), item.englishTitle);
    },
    title: alt
  }, /*#__PURE__*/React.createElement(LazyPicture, {
    useEmptyPlaceholder: true,
    hover: true
  }, /*#__PURE__*/React.createElement("source", {
    media: "(min-width: 768px)",
    srcSet: imgSrc
  }), /*#__PURE__*/React.createElement("img", {
    className: imgClassName,
    src: imgSrc,
    alt: alt,
    "aria-hidden": "true"
  })));
};
export var ArticleBlock = function ArticleBlock(_ref) {
  var item = _ref.item,
    copyBy = _ref.copyBy,
    copyMinread = _ref.copyMinread,
    lang = _ref.lang,
    hostLink = _ref.hostLink,
    callback = _ref.callback,
    analytics = _ref.analytics,
    _ref$removeDate = _ref.removeDate,
    removeDate = _ref$removeDate === void 0 ? false : _ref$removeDate;
  var eventsAnalytics = analytics.eventsAnalytics,
    params = analytics.params;
  return /*#__PURE__*/React.createElement("div", {
    className: "article article-item ".concat(get(item, 'curators.curators.length') >= 1 ? 'has-no-curators' : '')
  }, /*#__PURE__*/React.createElement("div", {
    className: "article__image"
  }, /*#__PURE__*/React.createElement("div", {
    className: "small_image"
  }, /*#__PURE__*/React.createElement(ScrollAnimation, {
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 0.8
  }, renderImage(item, 340, 243, item.title, 'small_image', eventsAnalytics['bannerClickAnalytics'], params, hostLink))), /*#__PURE__*/React.createElement(FavouriteBtn, {
    itemId: item && item.objectID,
    callback: callback,
    classes: 'article__icon',
    analyticsClick: function analyticsClick(e) {
      return tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics['addToFavAnalytics'], params), "".concat(e, ": ").concat(item.englishTitle));
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "article__content"
  }, /*#__PURE__*/React.createElement("ul", {
    className: "news__info-label-cnt"
  }, item.category && /*#__PURE__*/React.createElement("li", {
    className: "news__info-label"
  }, item.category), !removeDate && item.date && /*#__PURE__*/React.createElement("li", {
    className: "news__info-label"
  }, setDateFormat(item.date, lang)), item.category && /*#__PURE__*/React.createElement("li", {
    className: "news__info-label"
  }, item.location)), item.author && /*#__PURE__*/React.createElement("div", {
    className: "news__author"
  }, item.author), item.title && /*#__PURE__*/React.createElement(ScrollAnimation, {
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 1.05
  }, /*#__PURE__*/React.createElement("div", {
    className: "body-medium article__title"
  }, /*#__PURE__*/React.createElement(RouterLink, {
    href: getListingItemURL(hostLink, item.urlSlug, item.url),
    openInSameTab: true,
    onClick: function onClick() {
      return tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics['titleClickAnalytics'], params), item.englishTitle);
    }
  }, item.title))), item.authorImage && /*#__PURE__*/React.createElement(ScrollAnimation, {
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 1.1
  }, /*#__PURE__*/React.createElement("div", {
    className: "article__author"
  }, /*#__PURE__*/React.createElement("img", {
    className: "c-author__photo",
    src: baseImage + item.authorImage + '&cw=24&ch=24',
    alt: "Header"
  }), /*#__PURE__*/React.createElement("div", {
    className: "c-author__name"
  }, copyBy, " ", item.author), /*#__PURE__*/React.createElement("div", {
    className: "c-author__position"
  }))), item.readTime && item.readTime !== '0' && /*#__PURE__*/React.createElement(ScrollAnimation, {
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 1.15
  }, /*#__PURE__*/React.createElement("div", {
    className: "label-small article__time"
  }, item.readTime, " ", copyMinread))));
};
export var Articles = function Articles(_ref2) {
  var showNewsFeatured = _ref2.showNewsFeatured,
    type = _ref2.type,
    params = _ref2.params,
    fields = _ref2.fields,
    route = _ref2.route;
  var sitecoreContext = React.useContext(SitecoreContextReactContext);
  var isPersonalised = sitecoreContext.isPersonalised;
  var _React$useState = React.useState([]),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    searchResults = _React$useState2[0],
    setSearchResults = _React$useState2[1];
  var _React$useState3 = React.useState([]),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    validateItems = _React$useState4[0],
    setValidateItems = _React$useState4[1];
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var theme = get(sitecoreContext, 'themesOfPage');
  var themePrimary = get(theme, 'primary') || '';
  var _React$useState5 = React.useState(undefined),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    isHidden = _React$useState6[0],
    setIsHidden = _React$useState6[1];
  var _React$useState7 = React.useState({}),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    styleThemeHexColor = _React$useState8[0],
    setStyleThemeHexColor = _React$useState8[1];
  var currentLang = get(sitecoreContext, 'language');
  var moduleDictionary = get(fields, 'data.moduleDictionary');
  var parentId = get(fields, 'data.contextItem.parent.parentId', '').toLowerCase();
  var defaultTitle = getDictionaryItem(moduleDictionary, 'ArticlesTitle');
  var searchCount = Number(get(params, 'SearchCount')) + 1;
  var discoverMoreField = get(fields, 'data.overviewButton.title.jss') || {
    value: ''
  };
  var useCustomListingPage = get(fields, 'data.datasource.useCustomListingPage.jss.value');
  var considerPageLevelTags = get(fields, 'data.datasource.considerPageLevelTags.jss.value');
  var listingPageLink = get(fields, 'data.datasource.listingPageLink.jss.value.href');
  var discoverMoreLink = useCustomListingPage ? listingPageLink : get(fields, 'data.overviewButton.link.jss.value.href');
  var headerTitle = get(fields, 'data.datasource.title.jss') || {
    value: defaultTitle
  };
  var headerTitleValue = Boolean(get(headerTitle, 'value'));
  var primaryPageThemeColor = get(sitecoreContext, 'themesOfPage.primary');
  var primaryActivePageThemeColor = get(sitecoreContext, 'themesOfPage.primary_active');
  var _React$useState9 = React.useState(true),
    _React$useState10 = _slicedToArray(_React$useState9, 2),
    isVdsite = _React$useState10[0],
    setIsVdsite = _React$useState10[1];
  React.useEffect(function () {
    if (canUseDOM && !document.body.classList.contains('vdsite')) {
      setIsVdsite(false);
    }
  }, []);
  var BackgroundColorHex = get(params, 'BackgroundColorHex');
  var ActiveColorHex = get(params, 'ActiveColorHex');
  var selectedPrimaryColor = primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary;
  var selectedPrimaryActiveColor = primaryActivePageThemeColor ? primaryActivePageThemeColor : getPageThemeColors(isVdsite).primary_active;
  React.useEffect(function () {
    if (canUseDOM && document.body) {
      var ColorHex = get(params, 'ColorHex', canUseDOM && window.innerWidth < 768 ? '#000000' : '#ffffff');
      var primaryColor = BackgroundColorHex ? BackgroundColorHex : selectedPrimaryColor;
      var color = BackgroundColorHex ? ColorHex : getColorByTheme(selectedPrimaryColor);
      var activeColor = BackgroundColorHex ? ActiveColorHex : selectedPrimaryActiveColor;
      document.body.style.setProperty('--venue-table-background-color', primaryColor);
      document.body.style.setProperty('--venue-table-background-active-color', activeColor);
      document.body.style.setProperty('--venue-table-color', color);
      var styleThemeHexColorVar = BackgroundColorHex ? {
        '--articles-theme-hex-background-color': BackgroundColorHex,
        '--articles-theme-hex-color': ColorHex
      } : {
        '--articles-theme-hex-background-color': selectedPrimaryColor,
        '--articles-theme-hex-color': getColorByTheme(selectedPrimaryColor)
      };
      setStyleThemeHexColor(styleThemeHexColorVar);
    }
  }, [canUseDOM]);
  var itemType = type || 'articles';
  var currentPageID = get(route, 'itemId', '').split('-').join('');
  //  const currentPageID =  "9d787bea237c40f4beb927c236c0cf8c"
  var dummyId;
  if (process.env.STORYBOOK_MODE) {
    dummyId = '6a1d9e4935ad4273804e7cbc56f0d62b';
  }
  var contextItemId = get(fields, 'data.contextItem.id');
  var curtorListingPage = '';
  if (contextItemId) {
    curtorListingPage = "?curators.curators.Id=".concat(contextItemId);
  }
  var _React$useState11 = React.useState(''),
    _React$useState12 = _slicedToArray(_React$useState11, 2),
    seeMoreURLTags = _React$useState12[0],
    setSeeMoreURLTags = _React$useState12[1];
  var BackColor = themePrimary ? 'brand-bg' : '';
  var indexName = get(params, 'SearchIndex');
  var contextTags = getTags(get(fields, 'data.contextItem.tags'));
  // const [ref, inView] = useInView({ triggerOnce: false });
  var _React$useState13 = React.useState(false),
    _React$useState14 = _slicedToArray(_React$useState13, 2),
    isTriggered = _React$useState14[0],
    setIsTriggered = _React$useState14[1];
  var itemTags = get(fields, 'data.datasource') ? getTags(get(fields, 'data.datasource.tags')) : contextTags;
  var dictionaryValues = get(fields, 'data.dictionary.dictionaryValues') || [];
  var dictionary = get(fields, 'data.dictionary');
  var ReadNow = getDictionaryItem(moduleDictionary, 'ReadNow') || getDictionaryItem(dictionary, 'ReadMore');
  var showFeatured = Boolean(get(fields, 'data.datasource.showFeatured.jss.value'));
  var mapDictionary = dictionaryValues.reduce(function (map, currentValue) {
    return map.set(currentValue.key.jss.value, currentValue.phrase.jss.value);
  }, new Map());
  var contextItemTags = get(fields, 'data.contextItem.tags.values') || [];
  var datasourceTags = get(fields, 'data.datasource.tags.values') || [];
  var tagsRule = get(fields, 'data.datasource.tagsRule.jss.value');
  var isTagsRuleUsed = isTagsRule(tagsRule);
  var typeArticle = type === 'news' ? '' : 'type:Article';
  var ref = useRef();
  var isVisible = useIsVisible(ref);
  var formatTagsRuleToFilters = function formatTagsRuleToFilters() {
    var withType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var facetsFilters = [withType && [typeArticle]];
    if (isTagsRuleUsed) {
      var parsedTR = JSON.parse(tagsRule);
      if (parsedTR.length) {
        parsedTR.forEach(function (rule) {
          facetsFilters.push(rule);
        });
      }
    }
    return facetsFilters;
  };
  var tagsList = isTagsRuleUsed ? generateSeeMoreTagsFromRules(tagsRule) : considerPageLevelTags ? [].concat(_toConsumableArray(contextItemTags), _toConsumableArray(datasourceTags)) : _toConsumableArray(datasourceTags);
  var eventsAnalytics = get(fields, 'data.eventsAnalytics') || [];
  if (eventsAnalytics.length) {
    eventsAnalytics = convertToAnalyticObject(eventsAnalytics);
  }
  var intents = get(fields, 'data.datasource.intents');
  var intentsLength = get(intents, 'targetItems.length');
  var contextItem = get(fields, 'data.contextItem');

  // Resolve used conditions based on what is selected with the integrated query
  var conditions = resolveListPersonalization(intents, sitecoreContext);

  // Holder for all condition values
  var allValues = [];

  // Iterate all conditions and determine what the current user is tagged with.
  conditions && Array.isArray(conditions) && conditions.forEach(function (condition) {
    var handler = condition.handler,
      mappings = condition.mappings;
    var conditionValues = handler.getValues({
      mappings: mappings,
      sitecoreContext: sitecoreContext
    });
    if (conditionValues) {
      allValues.push.apply(allValues, _toConsumableArray(conditionValues));
    }
  });
  var _usePersonalizedList = usePersonalizedList({
      rendering: contextItem,
      route: route,
      list: searchResults,
      conditions: [algoliaScoredCondition(allValues)]
    }),
    personalizedList = _usePersonalizedList.personalizedList,
    refreshTracking = _usePersonalizedList.refreshTracking;
  React.useEffect(function () {
    setSeeMoreURLTags(generatrURLFromTags(tagsList));
    if (isVisible) {
      if (isPersonalised && intentsLength) {
        _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
          var hits;
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return loadCategoryAlgoliaResults(allValues || [], typeArticle, searchCount, isTagsRuleUsed ? formatTagsRuleToFilters(false) : considerPageLevelTags ? [].concat(_toConsumableArray(contextTags), _toConsumableArray(itemTags)) : _toConsumableArray(itemTags), [contextItemId ? "curators.curators.Id:".concat(contextItemId) : ''], currentPageID ? "NOT objectID:".concat(currentPageID) : '', indexName);
              case 2:
                hits = _context.sent;
                // setResults(hits);
                setSearchResults(hits);
                refreshTracking();
              case 5:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }))();
      } else {
        var filters = currentPageID ? "NOT objectID:".concat(currentPageID) : '';
        if (parentId) {
          filters = currentPageID ? "NOT objectID:".concat(currentPageID, " AND NOT objectID:").concat(parentId) : '';
        }
        var itemFilter = {
          hitsPerPage: searchCount,
          facetFilters: isTagsRuleUsed ? formatTagsRuleToFilters(true) : [[typeArticle], considerPageLevelTags ? [].concat(_toConsumableArray(contextTags), _toConsumableArray(itemTags)) : _toConsumableArray(itemTags)],
          // filters: currentPageID ? `NOT objectID:${currentPageID}` : '',
          filters: filters
        };
        var results = [];
        var hiddenResults = '';
        getListing(indexName, itemFilter).then(function (hits) {
          results.push(hits && hits.hits);
          results[0].map(function (result) {
            hiddenResults += " AND NOT objectID:".concat(result.objectID);
          });
          if (hits && hits.hits.length !== searchCount) {
            var _itemFilter = {
              hitsPerPage: searchCount - hits.hits.length,
              facetFilters: [typeArticle],
              filters: currentPageID ? " (NOT objectID:".concat(currentPageID, " ").concat(hiddenResults, ")") : " (NOT objectID:".concat(dummyId, " ").concat(hiddenResults, ")")
            };
            getListing(indexName, _itemFilter).then(function (hits) {
              results.push(hits && hits.hits);
              var finalResults = results[0].concat(results[1]);
              finalResults.length ? setIsHidden(false) : setIsHidden(true);
              setSearchResults(finalResults);
            });
          } else {
            results[0].length ? setIsHidden(false) : setIsHidden(true);
            results[0] && setSearchResults(results[0]);
          }
        });
      }
    }
  }, [itemType, isPersonalised, isVisible]);
  var hasItems;
  if (intentsLength && isPersonalised) {
    hasItems = Boolean(personalizedList && personalizedList.length);
  } else {
    hasItems = Boolean(searchResults && searchResults.length);
  }
  var smallItems;
  var firstItems;
  if (intentsLength && isPersonalised) {
    var featuredItemList = hasItems && personalizedList && personalizedList.length > 1 ? getFeaturedItemAndList(personalizedList) : [];
    smallItems = featuredItemList.list;
    firstItems = personalizedList && get(featuredItemList.featured, 'item');
  } else {
    var _featuredItemList = hasItems && searchResults.length > 1 ? getFeaturedItemAndList(searchResults) : [];
    smallItems = _featuredItemList.list;
    firstItems = _featuredItemList.featured;
  }
  var featured = Boolean(get(firstItems, 'featured')) && showFeatured;
  if (featured === false || showFeatured === false) {
    if (intentsLength && isPersonalised) {
      smallItems = personalizedList;
    } else {
      smallItems = searchResults;
    }
  }

  // if (!firstItems) {
  //   return <></>;
  // }

  var baseAuthorImgSrc = baseImage + get(firstItems, 'authorImage') + '&cw=24&ch=24';
  var renderTileItems = function renderTileItems(hostLink) {
    var itemsToMap = featured ? searchCount - 1 : searchCount;
    return smallItems && smallItems.slice(0, itemsToMap).map(function (item, index) {
      return /*#__PURE__*/React.createElement(ScrollAnimation, {
        animateIn: "animate__fadeInUp",
        animateOnce: true,
        duration: 1 + index / 3,
        key: "$article-carousel-tile-".concat(index)
      }, /*#__PURE__*/React.createElement(ArticleBlock, {
        item: item && item.item ? item.item : item,
        copyBy: mapDictionary.get('By'),
        copyMinread: mapDictionary.get('MinRead'),
        lang: currentLang,
        hostLink: hostLink,
        analytics: {
          eventsAnalytics: eventsAnalytics,
          params: params
        }
      }));
    });
  };
  var featuredItemWithColor = showFeatured === true && featured === true;
  React.useEffect(function () {
    setValidateItems(isPersonalised && intentsLength ? personalizedList : searchResults);
  }, [searchResults && searchResults.length, personalizedList && personalizedList.length]);
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    isHidden: true,
    anchorUrlParameter: params['Anchor Url Parameter']
  }, /*#__PURE__*/React.createElement("div", {
    style: styleThemeHexColor,
    ref: ref,
    className: "".concat(featured ? 'article article-multiple-featured' : '', " ").concat(get(firstItems, 'curators.curators.length') >= 1 ? 'has-no-curators' : '', " m02-articles")
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(featured ? 'article__featured' : '')
  }, /*#__PURE__*/React.createElement("div", {
    className: "article ".concat(!headerTitleValue && 'article-featured--no-heading', " article-featured ").concat(featuredItemWithColor ? "article-featured--colour theme-hex-color" : '')
  }, /*#__PURE__*/React.createElement(ScrollAnimation, {
    className: "article-featured__bg-animate",
    animateIn: "animate__slideInRight",
    animateOnce: true,
    duration: 1,
    offset: 150,
    delay: 0
  }, /*#__PURE__*/React.createElement("div", {
    className: "article-featured__bg-color theme-hex-color"
  })), /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "module-group module-group-theme-1"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-xl-1 d-none d-xl-block"
  }), /*#__PURE__*/React.createElement("div", {
    className: "col-xl-11 h-title-x"
  }, /*#__PURE__*/React.createElement(ScrollAnimation, {
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 1,
    offset: 100,
    delay: 0
  }, /*#__PURE__*/React.createElement(Text, {
    className: "".concat(showFeatured && featured === true ? 'h2 multipleTitle' : 'h3 article-title'),
    tag: "h4",
    field: headerTitle
  })))), showFeatured && featured === true && /*#__PURE__*/React.createElement(ScrollAnimation, {
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 1,
    offset: 300
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col"
  }, /*#__PURE__*/React.createElement("div", {
    className: "c-article"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-xl-1 d-xl-flex d-none remove-padding-mobile "
  }), /*#__PURE__*/React.createElement("div", {
    className: "col-md-12 col-xl-11 article-main-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row article-row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-5 article-header-theme remove-padding-mobile"
  }, /*#__PURE__*/React.createElement("div", {
    className: "article__header"
  }, /*#__PURE__*/React.createElement("div", {
    className: "c-header__image"
  }, /*#__PURE__*/React.createElement(RouterLink, {
    href: getListingItemURL(discoverMoreLink + curtorListingPage, firstItems.urlSlug, firstItems.url),
    openInSameTab: true,
    onClick: function onClick() {
      return tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics['bannerClickAnalytics'], params), firstItems.englishTitle);
    },
    title: firstItems.title
  }, /*#__PURE__*/React.createElement(LazyPicture, {
    useEmptyPlaceholder: true,
    hover: true
  }, /*#__PURE__*/React.createElement("source", {
    media: "(min-width: 480px)",
    srcSet: baseImage + firstItems.image + '&cw=460&ch=460'
  }), /*#__PURE__*/React.createElement("img", {
    className: "header_image",
    src: baseImage + firstItems.image + '&cw=325&ch=330',
    alt: firstItems.title
  })))))), /*#__PURE__*/React.createElement("div", {
    className: "col-md-6 col-xl-5 article-theme-white remove-padding-mobile"
  }, /*#__PURE__*/React.createElement("div", {
    className: "article__content"
  }, firstItems && firstItems.authorImage && /*#__PURE__*/React.createElement(ScrollAnimation, {
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 0.7
  }, /*#__PURE__*/React.createElement("div", {
    className: "article__author"
  }, /*#__PURE__*/React.createElement(LazyPicture, {
    className: "c-author__photo"
  }, /*#__PURE__*/React.createElement("source", {
    media: "(min-width: 480px)",
    srcSet: baseAuthorImgSrc
  }), /*#__PURE__*/React.createElement("img", {
    className: "c-author__photo",
    src: baseAuthorImgSrc,
    alt: "Author"
  })), /*#__PURE__*/React.createElement("div", {
    className: "c-author__name"
  }, mapDictionary.get('By'), " ", firstItems.author), /*#__PURE__*/React.createElement("div", {
    className: "c-author__position"
  }, firstItems.authorRole))), hasItems && /*#__PURE__*/React.createElement(ScrollAnimation, {
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 1
  }, /*#__PURE__*/React.createElement("div", {
    className: "label-small article__category"
  }, searchResults[0].category)), /*#__PURE__*/React.createElement("ul", {
    className: "news__info-label-cnt"
  }, firstItems.category && /*#__PURE__*/React.createElement("li", {
    className: "news__info-label"
  }, firstItems.category), firstItems.date && /*#__PURE__*/React.createElement("li", {
    className: "news__info-label"
  }, setDateFormat(firstItems.date, currentLang)), firstItems.category && /*#__PURE__*/React.createElement("li", {
    className: "news__info-label"
  }, firstItems.location)), firstItems.author && /*#__PURE__*/React.createElement("div", {
    className: "news__author"
  }, firstItems.author), hasItems && /*#__PURE__*/React.createElement(ScrollAnimation, {
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 1.05
  }, /*#__PURE__*/React.createElement("h3", {
    className: "h3 article__title"
  }, /*#__PURE__*/React.createElement(RouterLink, {
    href: getListingItemURL(discoverMoreLink + curtorListingPage, firstItems.urlSlug, firstItems.url),
    openInSameTab: true,
    onClick: function onClick() {
      return tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics['titleClickAnalytics'], params), firstItems.englishTitle);
    }
  }, firstItems.title))), /*#__PURE__*/React.createElement(ScrollAnimation, {
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 1.1
  }, /*#__PURE__*/React.createElement("div", {
    className: "c-content__text"
  }, firstItems.introText)), /*#__PURE__*/React.createElement("div", {
    className: "article__footer"
  }, /*#__PURE__*/React.createElement(ScrollAnimation, {
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 1.15
  }, /*#__PURE__*/React.createElement(RouterLink, {
    className: "btn btn-link",
    openInSameTab: true,
    href: getListingItemURL(discoverMoreLink + curtorListingPage, firstItems.urlSlug, firstItems.url),
    onClick: function onClick() {
      return tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics['readMoreAnalytics'], params), firstItems.englishTitle);
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "btn-link__text"
  }, ReadNow), rtl ? /*#__PURE__*/React.createElement(ChevronLeft, {
    className: "btn-link__icon btn-link-icon "
  }) : /*#__PURE__*/React.createElement(ChevronRight, {
    className: "btn-link__icon btn-link-icon"
  }))), type !== 'news' && /*#__PURE__*/React.createElement(ScrollAnimation, {
    className: "btn-like__animation-item",
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 1.15
  }, /*#__PURE__*/React.createElement("div", {
    className: "btn-like"
  }, /*#__PURE__*/React.createElement(FavouriteBtn, {
    itemId: firstItems && firstItems.objectID,
    classes: 'article__icon',
    analyticsClick: function analyticsClick(e) {
      return tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics['addToFavAnalytics'], params), "".concat(e, ": ").concat(firstItems.englishTitle));
    }
  })))))))))))))))), /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "module-group article-multiple-group "
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-xl-1 d-xl-flex d-none"
  }), /*#__PURE__*/React.createElement("div", {
    className: "col-xl-11 article__multiple"
  }, /*#__PURE__*/React.createElement("div", {
    className: "article article-multiple"
  }, /*#__PURE__*/React.createElement("div", {
    className: "article__list row"
  }, showFeatured && featured === true && /*#__PURE__*/React.createElement("div", {
    className: "d-none d-lg-block col-lg-1 article__offset"
  }), /*#__PURE__*/React.createElement("div", {
    className: "col-md-12 col-xl-10"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, validateItems && validateItems.length > 0 && /*#__PURE__*/React.createElement(CarouselProvider, null, function (_ref4) {
    var renderCarousel = _ref4.renderCarousel,
      renderPreviousButton = _ref4.renderPreviousButton,
      renderNextButton = _ref4.renderNextButton,
      renderDots = _ref4.renderDots,
      state = _ref4.state;
    return /*#__PURE__*/React.createElement("div", {
      className: "article__items ".concat(rtl && get(state, 'slidesToShow') >= get(state, 'totalItems') ? 'item-rtl-carousal-fix' : '')
    }, /*#__PURE__*/React.createElement("div", {
      className: "list__items"
    }, renderTileItems(discoverMoreLink + curtorListingPage)), renderCarousel(renderTileItems(discoverMoreLink + curtorListingPage), {
      responsive: {
        desktop: {
          breakpoint: {
            max: 10000,
            min: 768
          },
          items: 3
        },
        tablet: {
          breakpoint: {
            max: 1200,
            min: 768
          },
          items: 3
        },
        mobileLandscape: {
          breakpoint: {
            max: 767,
            min: 480
          },
          items: 2
        },
        mobile: {
          breakpoint: {
            max: 479,
            min: 0
          },
          items: 1
        }
      }
    }), /*#__PURE__*/React.createElement("div", {
      className: "article-navigation__row"
    }, /*#__PURE__*/React.createElement("div", {
      className: "article-navigation__btn btn-group--left ".concat(rtl ? 'btn-group-rtl' : '')
    }, renderPreviousButton(function () {
      return tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics['prevNextNavAnalytics'], params));
    })), /*#__PURE__*/React.createElement("div", {
      className: "article-navigation__btn btn-group--right ".concat(rtl ? 'btn-group-rtl' : '')
    }, renderNextButton(function () {
      return tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics['prevNextNavAnalytics'], params));
    }))), /*#__PURE__*/React.createElement("div", {
      className: "c-pagination__dots"
    }, renderDots(function () {
      return tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics['navBubblesAnalytics'], params));
    })));
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-xs-12"
  }, /*#__PURE__*/React.createElement(ScrollAnimation, {
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 1,
    delay: 200
  }, /*#__PURE__*/React.createElement("div", {
    className: "article__link"
  }, /*#__PURE__*/React.createElement(RouterLink, {
    openInSameTab: true,
    className: "btn btn-link btn-desk",
    href: discoverMoreLink + curtorListingPage + seeMoreURLTags,
    onClick: function onClick() {
      return tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics['seeMoreAnalytics'], params));
    },
    title: "".concat(headerTitle.value, " - ").concat(discoverMoreField.value)
  }, /*#__PURE__*/React.createElement(Text, {
    className: "btn-link__text",
    tag: "span",
    field: discoverMoreField
  }), rtl ? /*#__PURE__*/React.createElement(ChevronLeft, {
    className: "btn-link__icon btn-link-icon"
  }) : /*#__PURE__*/React.createElement(ChevronRight, {
    className: "btn-link__icon btn-link-icon"
  })), /*#__PURE__*/React.createElement(RouterLink, {
    openInSameTab: true,
    className: "btn btn-link btn-mob rs_skip",
    href: discoverMoreLink + curtorListingPage,
    onClick: function onClick() {
      return tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics['seeMoreAnalytics'], params));
    },
    title: "".concat(headerTitle.value, " - ").concat(discoverMoreField.value)
  }, /*#__PURE__*/React.createElement(Text, {
    className: "btn btn-primary",
    tag: "span",
    field: discoverMoreField
  })))))), showFeatured && featured === true && /*#__PURE__*/React.createElement("div", {
    className: "d-none d-lg-block col-lg-2"
  }))))))))));
};
var StyledWrapper = function StyledWrapper(_ref5) {
  var children = _ref5.children,
    rtl = _ref5.rtl,
    isHidden = _ref5.isHidden,
    anchorUrlParameter = _ref5.anchorUrlParameter;
  return /*#__PURE__*/React.createElement(React.Fragment, null, ' ', !(isHidden !== undefined && !isHidden) ? /*#__PURE__*/React.createElement(ComponentsWrapper, {
    anchorUrlParameter: anchorUrlParameter,
    minHeight: true,
    className: "".concat(commonStyles, "  ").concat(rtl ? rtlStyles : ltrStyles, " ").concat(ColorsLogic)
  }, children) : null, ' ');
};
var ColorsLogic = "c1trmzp0";
var commonStyles = "c87gwmg";
var ltrStyles = "l1ghfigj";
var rtlStyles = "rmbflte";
export default Articles;